var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useContext, useCallback } from 'react';
import { Link } from 'react-router-dom';
// eslint-disable-next-line import/named
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import FormControl from '@mui/material/FormControl';
import RadioGroup from '@mui/material/RadioGroup';
import FormLabel from '@mui/material/FormLabel';
import InputLabel from '@mui/material/InputLabel';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import IconButton from '@mui/material/IconButton';
// eslint-disable-next-line import/named
import Select from '@mui/material/Select';
import OutlinedInput from '@mui/material/OutlinedInput';
import MenuItem from '@mui/material/MenuItem';
import Checkbox from '@mui/material/Checkbox';
import ListItemText from '@mui/material/ListItemText';
import TextField from '@mui/material/TextField';
import ClearIcon from '@mui/icons-material/Clear';
import { getUserChats, getUsers } from '../api';
import ApiContext from '../contexts/apiContext';
import Menu from './Menu';
import Combo from './Combo';
var AdminMenu = function (_a) {
    var _b;
    var messageFilters = _a.messageFilters, setMessageFilters = _a.setMessageFilters;
    var _c = useState((_b = messageFilters.query) !== null && _b !== void 0 ? _b : ''), query = _c[0], setQuery = _c[1];
    var apiBaseUrl = useContext(ApiContext).apiBaseUrl;
    var sinceDate = messageFilters.since && !isNaN(new Date(messageFilters.since).getTime()) ? new Date(messageFilters.since) : null;
    var toDate = messageFilters.to && !isNaN(new Date(messageFilters.to).getTime()) ? new Date(messageFilters.to) : null;
    var roleArray = messageFilters.role
        ? Array.isArray(messageFilters.role)
            ? messageFilters.role
            : [messageFilters.role]
        : [];
    var setUserId = function (userId) { return setMessageFilters(__assign(__assign({}, messageFilters), { userId: userId })); };
    var setChatId = function (chatId) { return setMessageFilters(__assign(__assign({}, messageFilters), { chatId: chatId })); };
    var handleSinceAccept = function (since) {
        return setMessageFilters(__assign(__assign({}, messageFilters), { since: since === null || since === void 0 ? void 0 : since.toISOString() }));
    };
    var handleToAccept = function (to) { return setMessageFilters(__assign(__assign({}, messageFilters), { to: to === null || to === void 0 ? void 0 : to.toISOString() })); };
    var handleRoleChange = function (_a) {
        var role = _a.target.value;
        return setMessageFilters(__assign(__assign({}, messageFilters), { role: role }));
    };
    var handleQueryChange = function () { return setMessageFilters(__assign(__assign({}, messageFilters), { query: query })); };
    var handleSortChange = function (_, sort) {
        return setMessageFilters(__assign(__assign({}, messageFilters), { sort: sort }));
    };
    var handleQueryContentChange = function (e) { return setQuery(e.target.value); };
    var handleQueryKeyDown = function (e) {
        if (e.key !== 'Enter') {
            return;
        }
        e.preventDefault();
        handleQueryChange();
    };
    var handleQueryBlur = function () {
        handleQueryChange();
    };
    var handleClear = function () {
        setQuery('');
        setMessageFilters({});
    };
    var handleClearSearch = function () {
        setQuery('');
        setMessageFilters(__assign(__assign({}, messageFilters), { query: undefined }));
    };
    var fetchChatOptions = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var chats;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!messageFilters.userId) {
                        return [2 /*return*/, []];
                    }
                    return [4 /*yield*/, getUserChats(apiBaseUrl, messageFilters.userId)];
                case 1:
                    chats = _a.sent();
                    return [2 /*return*/, chats.map(function (_a) {
                            var id = _a.id, name = _a.name;
                            return ({ id: id, label: name });
                        })];
            }
        });
    }); }, [messageFilters]);
    var fetchUserOptions = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var users;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getUsers(apiBaseUrl)];
                case 1:
                    users = _a.sent();
                    return [2 /*return*/, users.map(function (user) { return ({ id: user.userId, label: user.username || user.userId }); })];
            }
        });
    }); }, [messageFilters]);
    var datePickerSlotProps = {
        actionBar: {
            actions: ['clear']
        }
    };
    var footer = (_jsx(Button, { variant: "outlined", component: Link, startIcon: _jsx(ArrowBackIcon, {}), to: "/", sx: { ml: 2, mr: 2, mt: 2 }, children: "Back" }));
    return (_jsx(Menu, { footer: footer, children: _jsxs(Stack, { width: "100%", spacing: 2, sx: { overflowY: 'auto' }, p: 1, flexGrow: 1, children: [_jsx(Combo, { label: "Users", selectedOptionId: messageFilters.userId, setSelectedOptionId: setUserId, fetchOptions: fetchUserOptions }), _jsx(Combo, { label: "Chats", disabled: !messageFilters.userId, selectedOptionId: messageFilters.chatId, setSelectedOptionId: setChatId, fetchOptions: fetchChatOptions }), _jsx(DatePicker, { label: "Since", onAccept: handleSinceAccept, value: sinceDate, slotProps: datePickerSlotProps, disableFuture: true }), _jsx(DatePicker, { label: "To", onAccept: handleToAccept, value: toDate, slotProps: datePickerSlotProps }), _jsxs(FormControl, { children: [_jsx(InputLabel, { children: "Chat role" }), _jsx(Select, { multiple: true, value: roleArray, onChange: handleRoleChange, input: _jsx(OutlinedInput, { label: "Chat role" }), renderValue: function (selected) { return selected.join(', '); }, children: ['assistant', 'user'].map(function (roleName) { return (_jsxs(MenuItem, { value: roleName, children: [_jsx(Checkbox, { checked: roleArray.includes(roleName) }), _jsx(ListItemText, { primary: roleName })] }, roleName)); }) })] }), _jsx(TextField, { label: "Search text", variant: "outlined", onBlur: handleQueryBlur, onChange: handleQueryContentChange, onKeyDown: handleQueryKeyDown, value: query, InputProps: {
                        endAdornment: (_jsx(IconButton, { sx: { visibility: query.trim() ? 'visible' : 'hidden' }, onClick: handleClearSearch, children: _jsx(ClearIcon, {}) }))
                    } }), _jsxs(FormControl, { children: [_jsx(FormLabel, { children: "Order" }), _jsxs(RadioGroup, { value: messageFilters.sort || 'asc', onChange: handleSortChange, children: [_jsx(FormControlLabel, { value: "asc", control: _jsx(Radio, {}), label: "Ascending" }), _jsx(FormControlLabel, { value: "desc", control: _jsx(Radio, {}), label: "Descending" })] })] }), _jsx(Button, { variant: "outlined", startIcon: _jsx(ClearIcon, {}), onClick: handleClear, children: "Clear all" })] }) }));
};
export default AdminMenu;
